export default "__VITE_ASSET__Bn2ED1FW__"